function redraw(delay){
	const html = document.querySelector('html');
	setTimeout(() => {
		html.style.display = 'none';
		setTimeout(()=>html.style.display = '',0);
	},delay || 100);
}
export default redraw;